
import React, { useEffect } from 'react';
import PocketBase from "pocketbase";

const pb = new PocketBase(process.env.REACT_APP_POCKETBASE_URL);

const SocialMediaCard = ({
  id,
  collectionId,
  platform,
  title,
  description,
  thumbnailUrl,
  link,
}) => {
  const getPlatformStyles = (platform) => {
    switch (platform) {
      case 'youtube':
        return { borderColor: '#FE0000' };
      case 'facebook':
        return { borderColor: '#3b5998' };
      case 'tiktok':
        return { borderColor: '#000000' };
      default:
        return { borderColor: '#CCCCCC' };
    }
  };

  const platformStyle = getPlatformStyles(platform);

  return (
    <div
      className='social-media-card'
      style={{
        border: `5px solid ${platformStyle.borderColor}`,
        padding: '10px',
        margin: '10px',
        borderRadius: '5px',
      }}
    >
      <a
        href={link}
        target='_blank'
        rel='noopener noreferrer'
        style={{ textDecoration: 'none', color: 'inherit' }}
      >
        <img
          src={`${process.env.REACT_APP_POCKETBASE_URL}/api/files/${collectionId}/${id}/${thumbnailUrl}`} 
          alt={title}
          style={{ width: '100%', borderRadius: '5px 5px 0 0' }}
        />
        <div style={{ padding: '10px' }}>
          <h3 style={{ margin: '0 0 10px', color: platformStyle.borderColor }}>{title}</h3>
          <p style={{ margin: '0' }}>{description}</p>
        </div>
      </a>
    </div>
  );
};

const SocialMediaCardPreview = () => {
  const [cards, setCards] = React.useState([]);

  useEffect(() => {
    const fetchCards = async () => {
      try {
        const response = await pb.collection("SocialMedia").getFullList();
        setCards(response);
      } catch (error) {
        console.error("Error fetching cards:", error);
      }
    }
    fetchCards();
  },[])

  return (
    <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-4 gap-2 px-4 py-2 justify-items-center">
      {cards.map((card, index) => (
        <SocialMediaCard key={index} {...card} />
      ))}
    </div>
  );
};

export default SocialMediaCardPreview;
